import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
} from "reactstrap";

interface EOP {
  id: number; 
  eopId: number;
  eopName: string;
  quantityDelivered: number;
  remainingQuantity: number;
}

interface DeliveryData {
  id: number;
  acceptedDateTime: string;
  inputDeliveryDetails: EOP[];
  purchaseOrderResponseModel: {
    supplierName: string;
    purchaseOrderEOPs: {
      eopId: number;
      eopName: string;
      quantityRequested: number;
      deliveredQuantity: number;
      
    }[];
  };
}

interface ViewDeliveryProps {
  isOpen: boolean;
  toggle: () => void;
  deliveryData: DeliveryData | DeliveryData[] | null; 
}

const ViewDelivery: React.FC<ViewDeliveryProps> = ({ 
  isOpen, 
  toggle, 
  deliveryData 
}) => {
  if (!deliveryData) return null;


  const deliveries = Array.isArray(deliveryData) ? deliveryData : [deliveryData];

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Delivery Details
      </ModalHeader>
      <ModalBody>
        {deliveries.map((delivery, deliveryIndex) => (
          <div key={delivery.id} className="mb-5">
            <h6 className="font-weight-bold mb-3">
              Delivery #{deliveryIndex + 1} - {new Date(delivery.acceptedDateTime).toLocaleDateString()}
            </h6>
            <Table bordered>
              <tbody>
                <tr>
                  <th style={{ width: '30%' }}>Delivery Date</th>
                  <td>
                    {new Date(delivery.acceptedDateTime).toLocaleDateString()}
                  </td>
      
                </tr>
                <tr>
                  <th>Supplier</th>
                  <td>{delivery.purchaseOrderResponseModel.supplierName}</td>
                </tr>
              </tbody>
            </Table>

            <h6 className="font-weight-bold mb-3 mt-4">Delivered Items</h6>
            <Table bordered striped>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Requested Qty</th>
                  <th>Delivered Qty</th>
                  <th>Remaining Qty</th>
                  <th>Date And Time</th>
                </tr>
              </thead>
              <tbody>
                {delivery.inputDeliveryDetails.map((item, itemIndex) => {
                  const eop = delivery.purchaseOrderResponseModel.purchaseOrderEOPs.find(
                    (eop) => eop.eopId === item.eopId
                  );
                 
                  return (
                    <tr key={item.id}>
                      <td>{itemIndex + 1}</td>
                      <td>{item.eopName}</td>
                      <td>{eop ? eop.quantityRequested : 'N/A'}</td>
                      <td>{item.quantityDelivered}</td>
                      <td>{item.remainingQuantity}</td>
                      <td>
                        {new Date(delivery.acceptedDateTime).toLocaleString()}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        ))}

        <div className="text-right mt-4">
          <Button className="btn-create px-4 py-2 shadow bg-or ml-4" onClick={toggle}>
            Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ViewDelivery;